import { Accordion } from "@mantine/core";
import style from "./faq.module.css";
import { useTranslation } from "react-i18next";

const FAQSegment = () => {
    const { t } = useTranslation("landing-page");

    const faqs = [
        {
            value: "faq.ai_detection.question",
            description: "faq.ai_detection.answer",
        },
        {
            value: "faq.teacher_usage.question",
            description: "faq.teacher_usage.answer",
        },
        {
            value: "faq.result_accuracy.question",
            description: "faq.result_accuracy.answer",
        },
        {
            value: "faq.data_handling.question",
            description: "faq.data_handling.answer",
        },
        {
            value: "faq.plagiarism_risk.question",
            description: "faq.plagiarism_risk.answer",
        },
        {
            value: "faq.unexpected_result.question",
            description: "faq.unexpected_result.answer",
        },
        {
            value: "faq.software_requirements.question",
            description: "faq.software_requirements.answer",
        },
        {
            value: "faq.supported_languages.question",
            description: "faq.supported_languages.answer",
        },
    ];

    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <h2 className={style.header}>{t("faq.title")}</h2>

                <Accordion className={style.accordion}>
                    {faqs.map((item) => (
                        <Accordion.Item key={item.value} value={item.value}>
                            <Accordion.Control icon={item.emoji}>
                                <p className={style.question}>{t(item.value)}</p>
                            </Accordion.Control>
                            <Accordion.Panel>
                                <pre className={style.answer}>{t(item.description)}</pre>
                            </Accordion.Panel>
                        </Accordion.Item>
                    ))}
                </Accordion>
            </div>
        </div>
    );
};

export default FAQSegment;
